export const tzs = (n) => `TZS ${Number(n || 0).toLocaleString("en-US")}`;
export const pts = (n) => `${Number(n || 0).toLocaleString("en-US")}`;

export const fmtDate = (s) =>
  s ? new Date(s).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "—";

export const fmtDateTime = (s) =>
  s
    ? new Date(s).toLocaleString("en-GB", {
        day: "numeric",
        month: "short",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "—";

export const timeAgo = (s) => {
  if (!s) return "—";
  const diff = (Date.now() - new Date(s).getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return fmtDate(s);
};

export const initials = (name) =>
  (name || "?")
    .split(" ")
    .map((w) => w[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

export const tierColor = (tier) =>
  ({ Bronze: "text-amber-500", Silver: "text-slate-300", Gold: "text-yellow-400" }[tier] || "text-primary");
